import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: any) => ({
  header: {
    borderBottom: `1px solid ${theme.palette.border.grayD3}`,
    maxHeight: "80px",
    // transition: 'all 0.5s ease-in-out',
    "&.MuiAppBar-root": {
      backgroundColor: theme.palette.colors.header,
      "&.inverse-Header": {
        backgroundColor: theme.palette.colors.header,
        "& $headerDesktop": {
          alignItems: "center",
        },
      },
    },
    // '&.shrink': {
    //   boxShadow: '0 0 5px hsl(0, 0%, 85%)',
    //   transition: 'all 0.5s ease-in-out',
    //   padding: theme.spacing(0)
    // }
  },
  headerToolbar: {
    justifyContent: "center",
    padding: "0",
    width: "100%",
  },
  headerInner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "1280px",
    padding: "0 32px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px",
    },
  },
  headerDesktop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1,
    position: "relative",
  },
  navCenter: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
  },
  headerGridContainer: {
    maxWidth: "1440px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
    },
  },
  iconWrapper: {
    color: theme.palette.primary.main,
    margin: theme.spacing(1),
    cursor: "pointer",
    "&:hover, &:focus": {
      color: theme.palette.primary.main,
      outline: "none",
    },
  },
  languageHeaderWrapper: {
    width: "220px",
    padding: "16px 8px",
    flexDirection: "column",
    display: "flex",
  },
  languageRadioHeaderWrapper: {
    justifyContent: "space-between",
    display: "flex",
  },
  languageText: {
    color: theme.palette.text.main,
    fontSize: "14px",
    fontWeight: 600,
    margin: "0px",
    textAlign: "start",
  },
  languageRadioWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },

  mobileMenu: {
    padding: "0 24px",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  menuContainer: {
    width: "320px",
    maxHeight: "480px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    padding: "16px",
  },
  oneMenuContainer: {
    width: "100%",
    height: "32px",
    backgroundColor: "#F8F9F9",
    padding: "8px 16px",
    cursor: "pointer",
    marginBottom: "8px",
  },
  menuTextsContainer: {
    width: "50%",
    overflow: "none",
    flexWrap:'wrap',
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "center",
    display: "flex",
  },
  menuTitleText: {
    color: "#49545B",
    font: "Roboto",
    fontWeight: 400,
    margin: "0px",
    textAlign: "start",
  },
  userNameMenuText: {
    color: "#000",
    font: "Roboto",
    fontWeight: 700,
    fontSize: "12px",
    width: "10px",
    margin: "0px",
    textAlign: "start",
  },
  userTypeText: {
    color: "#1E70FC",
    font: "Roboto",
    fontWeight: 700,
    fontSize: "10px",
    margin: "0px",
    textAlign: "start",
  },
  contactMenuContainer: {
    width: "90%",
    maxWidth: "75px",
    padding: "20px 16px",
    flexDirection: "row",
    alignContent: "center",
    display: "flex",
  },
}));
